import { ViewerOpenContextKind, type ContentViewerSession, type ViewerDownloadTarget } from '@/content-viewer/store/schemas'

export type ContentViewerCapabilities = {
  downloadTarget: ViewerDownloadTarget | null
  canDownload: boolean
  canOpenInNewTab: boolean
}

export function getContentViewerCapabilities(session: ContentViewerSession | null): ContentViewerCapabilities {
  if (!session) {
    return {
      downloadTarget: null,
      canDownload: false,
      canOpenInNewTab: false,
    }
  }

  const downloadTarget = session.document.downloadTarget ?? null

  return {
    downloadTarget,
    canDownload: Boolean(downloadTarget),
    canOpenInNewTab: session.context.kind === ViewerOpenContextKind.CHAT_CITATION,
  }
}
